import React, { FC, useMemo } from 'react'
import styled from 'styled-components'

import { Props as RadioProps, Radio } from './Radio'

export interface Props {
  fields: Array<RadioProps>
  onChange: (arg0: any) => void
  selectedValue: string
  disabled: boolean
}

export const RadioGroup: FC<Props> = ({ fields = [], onChange, selectedValue, disabled }) => {
  const filteredFields: Array<RadioProps> = useMemo(() => {
    return fields.map((field) => {
      field.checked = field.value === selectedValue
      return field
    })
  }, [fields, selectedValue])

  return (
    <StyledRadioGroup>
      {filteredFields.length &&
        filteredFields.map((field) => (
          <Radio key={field.value} {...field} onChange={(evt) => onChange(evt.target.value)} disabled={disabled} />
        ))}
    </StyledRadioGroup>
  )
}

const StyledRadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
`
